class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console.log("parsedState in renderContents:", parsedState);

    if (!parsedState) {
      console.error("parsedState ist undefined oder null.");
      return;
    }

    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    // Holen und Aktualisieren der Cart-Daten
    this.fetchCartState(); // NEUE FUNKTION HINZUGEFÜGT
    this.open();
  }

  fetchCartState() {
    fetch('/cart.js')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((cartState) => {
        this.updateCartTotal(cartState); // Cart-Daten verwenden
      })
      .catch((error) => {
        console.error('Fehler beim Abrufen des Warenkorbs:', error);
      });
  }

  updateCartTotal(cartState) {
    try {
      // Sicherstellen, dass cartState und items existieren
      if (!cartState || !cartState.items) {
        console.error("cartState oder items nicht verfügbar");
        return;
      }

      // Gesamtpreis berechnen
      const totalPrice = cartState.items.reduce((total, item) => {
        return total + (item.final_line_price || 0);
      }, 0);

      // Preis formatieren
      const formattedPrice = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }).format(totalPrice / 100); // Shopify gibt Preise in Cent zurück

      // Gesamtpreis-Element aktualisieren
      const totalElement = this.notification.querySelector('.cart-notification-total');
      if (totalElement) {
        totalElement.textContent = `Gesamt: ${formattedPrice}`;
      } else {
        console.warn("Element für Gesamtpreis nicht gefunden");
      }
    } catch (error) {
      console.error("Fehler in updateCartTotal:", error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
